import React from 'react'
import s from './ProfileFollowing.module.scss'
import { ReactComponent as BackIcon } from '../../../../../images/new-icons/arrow-go-back.svg'
import { useNavigate } from 'react-router-dom'
import useUser from 'sdk/hooks/user/useUser'
import useUserFollowingSalonsList from 'sdk/hooks/follow/useUserFollowingSalonsList'
import Avatar from 'components/shared/Avatar'

const ProfileFollowing = () => {
  const navigate = useNavigate()
  const { data: currentUser } = useUser()
  const userId = currentUser?.user?.id
  const { data: followingData } = useUserFollowingSalonsList(userId || '')

  const following = followingData?.pages?.flat() || []

  return (
    <div className={s.container}>
      <div className={s.header}>
        <BackIcon className={s.header_back} onClick={() => navigate(-1)} />
        <div className={s.header_title}>Following</div>
      </div>

      <div className={s.followingList}>
        {following.map((follow) => (
          <div key={follow.id} className={s.content} onClick={() => navigate(`/salon/${follow.salon?.id}`)}>
            <div className={s.content_left}>
              <Avatar
                className={s.content_left_avatar}
                image={follow.salon?.avatar}
              />
              <div className={s.content_left_info}>
                <div className={s.content_left_info_name}>
                  {`${follow.salon?.first_name || ''} ${follow.salon?.last_name || ''}`}
                </div>
                <div className={s.content_left_info_username}>
                  {follow.salon?.username}
                </div>
              </div>
            </div>
            <div className={s.content_right}>
              <div className={s.content_right_title}>
                Following
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProfileFollowing